import React from 'react';

import style from './scss/style'
import { useTheme, styled } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';

import { motion } from "framer-motion"

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        backgroundColor: theme.palette.menu.background.dark,
        height: '100%',
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
})

const CustomTypography = styled(Typography)(({ theme }) => {
    return {
        color: 'white'
    }
})

const SplashLoader = () => {

    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7 }}
            style={{ position: 'fixed', height: '100%', width: '100%', zIndex: 100 }}
        >
            <CustomPaper className={style.root} elevation={0}>
                <Box className={style.content}>
                    <Box className={style.svgWrapper}>
                        <svg viewBox="0 0 208 116" width="100%" height="100%">
                            <path
                                fill="rgba(0,0,0,0)"
                                stroke={theme.palette.primary.main}
                                d="M116.83 44.9L127.26 33.73C137.03 24.77 151.24 22.57 163.26 28.17C175.28 33.77 182.74 46.05 182.17 59.3C181.6 72.55 173.1 84.14 160.64 88.68C148.19 93.22 134.22 89.81 125.26 80.04L80 33.73C70.23 24.77 56.02 22.57 44 28.17C31.98 33.77 24.52 46.05 25.09 59.3C25.66 72.55 34.16 84.14 46.62 88.68C59.07 93.22 73.04 89.81 82 80.04L90.63 71.31"
                            />
                        </svg>
                    </Box>
                    {matches
                        ? <Box className={style.titleWrapper}>
                            <CustomTypography variant='h2' className={style.title}>MonadSearch</CustomTypography>
                            <CustomTypography variant='h5' className={style.subTitle}>by Monetizead</CustomTypography>
                        </Box>

                        : <Box className={style.titleWrapper}>
                            <CustomTypography style={{ fontSize: '2rem' }} variant='h2' className={style.title}>MonadSearch</CustomTypography>
                            <CustomTypography style={{ fontSize: '1rem' }} variant='h5' className={style.subTitle}>by Monetizead</CustomTypography>
                        </Box>}

                </Box>
            </CustomPaper>
        </motion.section>
    )
}

export default SplashLoader